/**
 * Created by BFR on 07/09/2015.
 */
define('adminLisDetailsView',[
  'module',
  'marionette',
  'underscore',
  'backbone',
  'app',
  'settings',
  'imageUtils',
  'template!adminLisDetailsTpl',
  'adminLisTabs',
  'rolesMixin',
  'backToListBehavior'
], function (
  module,
  Marionette,
  _,
  Backbone,
  App,
  Settings,
  imageUtils,
  viewTpl,
  lisTabs,
  RolesMixin,
  BackToListBehavior
) {
  'use strict';

  var LisDetailsView =  Marionette.LayoutView.extend({
    template: viewTpl,

    ui: {
      tab: '.lis-tab',
      tabPane: '.tab-pane',
      logo: '.js-logo-holder',
      name: '.p-name',
      code: '.p-code'
    },

    events: {
      'click @ui.tab': 'onTabClick',
      'change @ui.collectionToggle': 'onCollectionToggle'
    },

    regions: {
      lisDetailTab: '#detail-tab',
      lisAnaListTab: '#lisana-tab',
      lisAserieListTab: '#lisaserie-tab',
      lisSmpMatListTab: '#lissmpmat-tab'
    },

    behaviors: {
      BackToList: {
        behaviorClass: BackToListBehavior,
        redirectUrl: 'admin/lis'
      }
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.lisTabs = lisTabs;
      templateData.compulogoCollection = this.model.get('compulogoCollection');
      return templateData;
    },

    onRender: function() {
      if (this.options.data.tab) {
        this.ui.tab.removeClass('active');
        this.$el.find('.tab-pane').removeClass('active');
        this.$el
          .find('.lis-tab[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
        this.$el
          .find('.tab-pane[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
      }
    },

    onShow: function() {
      $.material.init();
    },

    onTabClick: function(e) {
      var $target = $(e.currentTarget),
        tab = {
          route: $target.data('route'),
          role: $target.data('role'),
          name: $target.data('name')
        };

      this.ui.tab.removeClass('active');
      this.ui.tabPane.removeClass('active');
      $target.addClass('active');
      this.$('.tab-pane[data-name="' + tab.name + '"]').addClass('active');

      this.triggerMethod('click:tab', tab);
    },

    onHeaderChange: function(lis) {
      this.ui.name.text(lis.name);
      this.ui.code.text(lis.code);
    }
  });

  module.exports = LisDetailsView;
});
